import { render } from "@/components/pages/individualWorkSupport/requirement089/Requirement089.html?vue&type=template&id=b83e6f40&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement089/Requirement089.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement089/Requirement089.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement089/Requirement089.scss?vue&type=style&index=0&id=b83e6f40&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b83e6f40"]])

export default __exports__